import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n  width: 150px;\n  margin: 1rem auto;\n  padding: 8px 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #25d366;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  &:hover {\n    background-color: #1fb851;\n  }\n"]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n  width: 250px;\n  margin: -4rem auto 1rem auto;\n  text-align: center;\n  padding: 10px;\n  position: relative;\n  z-index: 10;\n  background-color: #f8f9fa;\n  border-radius: 12px;\n  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e9ecef;\n"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  color: #000;\n  padding: 0.3rem;\n  margin: 0 auto;\n  text-align: center;\n  letter-spacing: 1px;\n  font-family: monospace;\n"]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n  font-size: 0.9rem;\n  font-weight: ", ";\n  color: #f76268;\n  margin-bottom: 0.5rem;\n  margin-top: 0;\n  text-transform: lowercase;\n  letter-spacing: 0.5px;\n  &::first-letter {\n    text-transform: uppercase;\n  }\n"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n  width: 250px;\n  margin: 2rem auto;\n  text-align: center;\n  padding: 10px;\n  background-color: #f8f9fa;\n  border-radius: 12px;\n  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e9ecef;\n  height: 150px;\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n  width: 230px;\n  margin: 0 auto;\n  padding: 10px 20px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  background-color: #25d366;\n  border-radius: 20px;\n  &::first-letter {\n    text-transform: uppercase;\n  }\n  div {\n    display: flex;\n    align-items: center;\n    width: 35px;\n    heigth: 35px;\n    transform: rotate(110deg);\n  }\n"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  align-self: center;\n  font-size: 1rem;\n  text-align: center;\n  text-transform: lowercase;\n  color: white;\n  &::first-letter {\n    text-transform: uppercase;\n  }\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1rem;\n  text-align: center;\n  padding: 0.5rem 0 0.5rem 0;\n  margin-top: 0rem;\n  margin-bottom: 0rem;\n  color: grey;\n  text-transform: lowercase;\n  &::first-letter {\n    text-transform: uppercase;\n  }\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1rem;\n  text-align: center;\n  padding: 0.5rem 0 0.5rem 0;\n  margin-top: 3rem;\n  margin-bottom: 3rem;\n  color: grey;\n  text-transform: lowercase;\n  &::first-letter {\n    text-transform: uppercase;\n  }\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  width: 120px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  img {\n    width: 120px;\n    position: relative;\n    top: 50px;\n    object-fit: contain;\n  }\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  width: 5.2rem;\n  height: 80px;\n  div {\n    width: 5.2rem;\n  }\n  svg {\n    position: relative;\n    top: 8px;\n    width: 5.2rem;\n    height: 90px;\n    padding: 5px;\n    transform: scale(1.3);\n    margin: 0 auto;\n    margin-bottom: 15px;\n  }\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  height: 3.55rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  img {\n    position: relative;\n    top: 8px;\n    width: 3.2rem;\n    height: 50px;\n    padding: 5px;\n    margin: 0 auto;\n    margin-bottom: 15px;\n    border-radius: 50%;\n    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.3);\n    background-color: white;\n    object-fit: contain;\n  }\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  height: 3.55rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  svg {\n    position: relative;\n    top: 50px;\n    width: 3.2rem;\n    height: 50px;\n    padding: 5px;\n    margin: 0 auto;\n    margin-bottom: 15px;\n    border-radius: 50%;\n    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.3);\n    background-color: white;\n  }\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  heigth: auto;\n  margin: 0 auto;\n  margin-top: 3rem;\n  margin-bottom: 3rem;\n  display: grid;\n  grid-template-columns: 1fr 2fr 1fr;\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n    padding: 0 0 0.5rem 0;\n    border-bottom: 1px solid rgba(50, 50, 50, 0.1);\n    box-shadow: none;\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 0.6rem;\n  margin-bottom: 1rem;\n  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  border-bottom: none;\n  font-size: 1.5rem;\n  font-weight: ", ";\n  text-align: center;\n  text-transform: lowercase;\n  &::first-letter {\n    text-transform: uppercase;\n  }\n  ", "\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    padding: 0;\n    margin-bottom: 40px;\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  width: 90%;\n  margin: 0 auto;\n  padding-top: 30px;\n  ", "\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  grid-area: footer;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  grid-area: aside;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  width: 200px;\n  height: 30px;\n  padding-top: 5px;\n  margin: 0 auto;\n  text-align: center;\n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  text-transform: lowercase;\n  &::first-letter {\n    text-transform: uppercase;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: auto;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  align-self: center;\n  font-size: 1rem;\n  text-transform: lowercase;\n  &::first-letter {\n    text-transform: uppercase;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 50% 50%;\n  position: absolute;\n  top: 0.4rem;\n  left: 1rem;\n  color: #f76268;\n  cursor: pointer;\n  font-size: 1rem;\n  text-transform: uppercase;\n  div {\n    height: 35px;\n    align-self: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  svg {\n    transform: scale(0.4);\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    grid-template-rows: 40% 60%;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 90%;\n  height: 100%;\n  margin: 0 auto;\n  display: grid;\n  grid-template-rows: 40% 25% 35%;\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  grid-area: content;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  grid-area: tile;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    grid-template-areas:\n      \"content\"\n      \"aside\";\n    grid-template-columns: 100%;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-areas:\n    \"tile tile\"\n    \"content aside\"\n    \"footer footer\";\n  position: relative;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { styled, media } from "@styles";
export var Wrapper = styled.div(_templateObject(), media.xMediumScreen(_templateObject2()));
export var Tile = styled.div(_templateObject3());
export var Content = styled.div(_templateObject4());
export var ContentContainer = styled.div(_templateObject5(), media.xMediumScreen(_templateObject6()));
export var BackTitle = styled.div(_templateObject7());
export var BackTitleParragraph = styled.p(_templateObject8());
export var Delivery = styled.div(_templateObject9());
export var DeliveryTile = styled.p(_templateObject10());
export var DeliveryNumber = styled.div(_templateObject11());
export var Aside = styled.div(_templateObject12());
export var Footer = styled.div(_templateObject13());
export var Navigation = styled.div(_templateObject14(), media.xMediumScreen(_templateObject15()));
export var Title = styled.h3(_templateObject16(), function (props) {
  return props.theme.typography.boldFontWeight;
}, media.xMediumScreen(_templateObject17()));
export var Images = styled.div(_templateObject18());
export var Image = styled.div(_templateObject19());
export var ImageShop = styled.div(_templateObject20());
export var ImageHome = styled.div(_templateObject21());
export var Gif = styled.div(_templateObject22());
export var Parragraph = styled.p(_templateObject23());
export var ParragraphTwo = styled.p(_templateObject24());
export var ParragraphButton = styled.p(_templateObject25());
export var Link = styled.a(_templateObject26());
export var Button = styled.div(_templateObject27());
export var DeliveryCode = styled.div(_templateObject28());
export var DeliveryCodeTitle = styled.p(_templateObject29(), function (props) {
  return props.theme.typography.boldFontWeight;
});
export var DeliveryCodeNumber = styled.div(_templateObject30(), function (props) {
  return props.theme.typography.boldFontWeight;
});
export var DeliveryCodeMobile = styled.div(_templateObject31());
export var ViewRouteButton = styled.div(_templateObject32());